import FaqsWithMarkup from 'components/ModalFaqs/Sections/FaqsWithMarkup/styled';

export default FaqsWithMarkup;
